var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.825 10.875H8.175V6.825H6.825V10.875ZM7.5 0.75C3.77062 0.75 0.75 3.77062 0.75 7.5C0.75 11.2294 3.77062 14.25 7.5 14.25C11.2294 14.25 14.25 11.2294 14.25 7.5C14.25 3.77062 11.2294 0.75 7.5 0.75ZM7.5 12.9C4.52325 12.9 2.1 10.4768 2.1 7.5C2.1 4.52325 4.52325 2.1 7.5 2.1C10.4768 2.1 12.9 4.52325 12.9 7.5C12.9 10.4768 10.4768 12.9 7.5 12.9ZM6.825 5.475H8.175V4.125H6.825V5.475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info-gray.09fd1f89a3846b3da0f3a579f91bd03e.svg";
export { ForwardRef as ReactComponent };